/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 実行状況
 * @export
 * @enum {number}
 */
export enum ExecutionStatusEnum {
    /** 未完了 */
    NOT_EXECUTED = 0,
    /** 完了 */
    EXECUTED = 1
}

/**
 * 実行状況 の Union 型
 * @export
 * @typedef ExecutionStatus
 */
export type ExecutionStatus =
  typeof ExecutionStatusEnum[keyof typeof ExecutionStatusEnum];

/**
 * 実行状況 のラベルマップ
 * @export
 */
export const ExecutionStatusLabels = {
    /**
     * 数値キー: ExecutionStatusEnum.NOT_EXECUTED
     * 名前キー:  NOT_EXECUTED
     */
    [ExecutionStatusEnum.NOT_EXECUTED]: '未完了',
    NOT_EXECUTED:                             '未完了',
    /**
     * 数値キー: ExecutionStatusEnum.EXECUTED
     * 名前キー:  EXECUTED
     */
    [ExecutionStatusEnum.EXECUTED]: '完了',
    EXECUTED:                             '完了',
} as const;

/**
 * 実行状況 のラベル Union 型
 * @export
 * @typedef ExecutionStatusLabel
 */
export type ExecutionStatusLabel =
  typeof ExecutionStatusLabels[keyof typeof ExecutionStatusLabels];

/**
 * 実行状況 のラベル取得関数
 * @export
 * @param { ExecutionStatus } value - 列挙体の値
 * @returns { ExecutionStatusLabel } ラベル文字列
 */
export function getExecutionStatusLabel(
  value: ExecutionStatus
): ExecutionStatusLabel {
  return ExecutionStatusLabels[value];
}

/**
 * 実行状況 のラベル配列を取得する関数
 * @export
 * @param { ExecutionStatus[] } values - 列挙体の値配列
 * @returns { ExecutionStatusLabel[] } ラベル文字列配列
 */
export function getExecutionStatusLabels(values: ExecutionStatus[]): ExecutionStatusLabel[] {
  return values.map((value) => getExecutionStatusLabel(value));
}

/**
 * 実行状況 のラベル配列
 * @export
 */
export const ExecutionStatusLabelList = [
  '未完了','完了',
] as const;

